import * as React from 'react';
import {Provider} from 'react-redux';
import {store} from './store';
import {ClientDashboardComponent} from './Dashboard'


export function ClientDashboardContainer() {

  return (
    <Provider store={store}>
      <ClientDashboardComponent />
    </Provider>
  )
}
